import { tsValidate_OptionalArray, tsValidateOptionalAnyNumber, tsValidateString, tsValidateUniqueId, } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
const Validator_EncounterExtraData = {
    age: tsValidateOptionalAnyNumber,
    gender: tsValidateString(-1, false),
    chiefComplaints: tsValidate_OptionalArray(tsValidateString()),
};
const Validator_OrganizationMetadata = {
    organizationId: tsValidateUniqueId,
    ehrInstanceId: tsValidateUniqueId,
    ehrInstallationId: tsValidateUniqueId,
    environmentId: tsValidateUniqueId,
    facilityId: tsValidateUniqueId,
    advisorConfigurationId: tsValidateUniqueId,
};
const Validator_MandatoryPropsEncounterData = {
    encounterExtraData: Validator_EncounterExtraData,
    organizationMetadata: Validator_OrganizationMetadata,
    patientId: tsValidateUniqueId,
    kbVersion: tsValidateString(),
    encounterStartTime: tsValidateOptionalAnyNumber,
};
const Validator_GeneratedProps = {};
export const DBDef_EncounterData = {
    modifiablePropsValidator: Validator_MandatoryPropsEncounterData,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'encounters-data',
    generatedProps: [],
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'encounters-data',
    },
    backend: {
        name: 'encounters-data',
    },
    entityName: 'EncounterData',
    dependencies: {
        'organizationMetadata.organizationId': {
            dbKey: 'organizations',
            fieldType: 'string',
        },
        'organizationMetadata.environmentId': {
            dbKey: 'environments',
            fieldType: 'string',
        },
        'organizationMetadata.facilityId': {
            dbKey: 'facility',
            fieldType: 'string',
        },
        'organizationMetadata.advisorConfigurationId': {
            dbKey: 'advisor-configurations',
            fieldType: 'string',
        },
        'organizationMetadata.ehrInstallationId': {
            dbKey: 'ehr-installations',
            fieldType: 'string',
        },
    },
};
//# sourceMappingURL=db-def.js.map